export default "__VITE_ASSET__BiSgUqSM__"